import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { File06 } from "untitledui-js-base";
import { UntitledIcon } from "../type";
import { cx } from "shared/utils";

export const EmptyStateRow = ({
  Icon,
  buttonText,
  buttonAction,
  title,
  maw,
  text,
  className
}: {
  title?: string;
  text?: string;
  maw?: number;
  buttonText?: string;
  buttonAction?: () => void;
  Icon?: UntitledIcon;
  className?: string;
}) => (
  <tr
    className={cx(
      "animate-appear absolute bottom-0 top-0 flex h-full -translate-x-1/2 flex-col items-center",
      className
    )}
    style={{
      left: maw ? `calc(${maw / 2}px)` : "50%"
    }}
  >
    <td colSpan={100} className="h-full">
      <div className="flex h-full flex-col items-center justify-center">
        <div className="mb-6 flex items-center justify-center rounded-full bg-alpha-40 p-8">
          {Icon ? (
            <Icon className="h-10 w-10 stroke-content-400" />
          ) : (
            <File06 className="h-10 w-10 stroke-content-400" />
          )}
        </div>
        <p className="mb-2 text-base font-bold">{title}</p>
        <p className="text-sm font-medium text-content-300 text-center">
          {text}
        </p>

        {buttonText && (
          <Button
            onClick={() => {
              buttonAction && buttonAction();
            }}
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.SM}
            className="mt-6"
          >
            {buttonText}
          </Button>
        )}
      </div>
    </td>
  </tr>
);
